/* src/app/workshop/pages/defects/defects.component.scss */
/*# sourceMappingURL=defects.component.css.map */
